import { ApplicationData, ApplicationFormData, ApplicationVehicle, PersonTypeOptions } from "pages/NewApplication/steps/types";

const ApplicationDataHelper = {
	isJuridical: (application: ApplicationData | ApplicationFormData) => {
		return application?.applicantData?.applicantType === PersonTypeOptions.juridical;
	},
	formatResponseDataVehicle: (applicationVehicle: ApplicationVehicle): ApplicationVehicle => {
		if (applicationVehicle?.vehicleModel?.includes("/")) {
			const [brand, model] = applicationVehicle?.vehicleModel?.split("/") || ["", ""];

			return {
				...applicationVehicle,
				vehicleBrand: brand,
				vehicleModel: model
			};
		}
		return applicationVehicle;
	},
	formatResponseDataDocuments: (applicationData: ApplicationData): ApplicationFormData => {
		return {
			...applicationData,
			applicationVehicle: ApplicationDataHelper.formatResponseDataVehicle(applicationData.applicationVehicle),
			documentFolders: Object.fromEntries(applicationData.documentFolders.map((folder) => [folder.exemptionDocumentFolderType, folder]))
		};
	}
};

export default ApplicationDataHelper;
